import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';

const Pin = styled.img.withConfig({ componentId: 'sc-1xj97hd-0' })`
  height: 20px;
  width: 20px;
  transition: transform 100ms ease;
  transform-origin: center bottom;
  transform: translate(center bottom);
  &:hover {
    transform: scale(2);
  }
  ${({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'hover' does not exist on type 'Pick<Deta... Remove this comment to see the full error message
    hover,
  }) =>
    hover &&
    css`
      transform: scale(2);
    `}
`;

type Props = {
  $hover?: boolean;
  className?: string;
};

export default class DefaultPin extends PureComponent<Props> {
  render = () => (
    <Pin
      alt="Map pin"
      className={this.props.className}
      // @ts-expect-error ts-migrate(2769) FIXME: Property 'hover' does not exist on type 'Intrinsic... Remove this comment to see the full error message
      hover={this.props.$hover}
      src="/images/icons/map_pin.svg"
    />
  );
}
